// extracted by mini-css-extract-plugin
export default {"AwesomeLists":"AwesomeLists_AwesomeLists__ShLad"};